export default "/images/company-default-image.5d2e79.png";